import { type JSX } from 'react/jsx-runtime';

export const JpdRoadmapDarkIcon = (): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="20" height="20" rx="4" fill="#48245d" />
		<path
			d="M6.286 5.158h5.52a2.858 2.858 0 0 1 0 5.714H8.379a1.333 1.333 0 1 0 0 2.667H13.9v1.523H8.38a2.858 2.858 0 0 1 0-5.714h3.428a1.333 1.333 0 1 0 0-2.667H6.286z"
			fill="#1868db"
		/>
		<path
			d="M6.286 8.186A2.284 2.284 0 0 0 8.57 5.901a2.284 2.284 0 0 0-2.285-2.286A2.284 2.284 0 0 0 4 5.901a2.284 2.284 0 0 0 2.286 2.285M16 12.195h-4.19v4.19H16z"
			fill="#fca700"
		/>
		<path d="M8.445 5.158A2.26 2.26 0 0 1 8.43 6.68H6.286V5.158z" fill="#09326c" />
		<path
			d="M8.569 5.898c0 .276-.049.54-.14.783H6.286V5.158h2.16q.121.35.123.74m4.931 10.16v-.998h-1.69v-1.524h1.69v-.998l1.757 1.76z"
			fill="#09326c"
		/>
	</svg>
);
